<template>
  <card-component>
    <div class="level is-mobile">
      <div class="level-item">
        <div class="is-widget-label">
          <h3 class="subtitle is-spaced">
            {{ label }}
          </h3>
          <div v-if="prefixSign">
            <h1 class="title">
              <growing-number :value="number" :prefix="prefix"/>
            </h1>
            <p>
              <small>
                <growing-number :value="percentage" :prefix="prefixSign" :suffix="suffix" secondsuffix=" vs últimos 7 días"/>
              </small>
            </p>
          </div>
        </div>
      </div>
      <div v-if="icon">
        <div class="is-widget-icon">
          <b-icon :icon="icon" size="is-large" :type="type"/>
        </div>
      </div>
    </div>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import GrowingNumber from '@/components/GrowingNumber'
export default {
  name: 'CardWidget',
  components: { GrowingNumber, CardComponent },
  props: {
    icon: {
      type: String,
      default: null
    },
    number: {
      type: Number,
      default: 0
    },
    percentage: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: null
    },
    prefixSign: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  }
}
</script>
